import {configureStore} from "@reduxjs/toolkit";
import storeLocatorSettingsSlice from "./storeLocatorSettingsSlice";
import isSearchOccurredSlice from "./isSearchOccurredSlice";
import storeSearchCircleSlice from "./storeSearchCircleSlice";
import isSearchFormLoadingSlice from "./isSearchFormLoadingSlice";
import searchResultsSlice from "./searchResultsSlice";
import locationDefinitionModeSlice from "./locationDefinitionModeSlice";

const BilJacAppStore = configureStore({
    reducer: {
        storeLocatorSettingsSlice: storeLocatorSettingsSlice.reducer,
        isSearchOccurredSlice: isSearchOccurredSlice.reducer,
        storeSearchCircleSlice: storeSearchCircleSlice.reducer,
        isSearchFormLoadingSlice: isSearchFormLoadingSlice.reducer,
        searchResultsSlice: searchResultsSlice.reducer,
        locationDefinitionModeSlice: locationDefinitionModeSlice.reducer
    }
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof BilJacAppStore.getState>;

// Inferred type for Action Creators (reducers)
export type AppDispatch = typeof BilJacAppStore.dispatch;

export default BilJacAppStore;